import { gql } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { getAdditionalFilters } from '@/hooks/useInvestingIdeaScreener/utils';

export type QueryKeyParams = {
  limit: number;
  initPage: number;
  market: string;
};

export type QueryKeyResult = [string, number, number, string];

export const getQueryKey = ({
  limit,
  initPage,
  market,
}: QueryKeyParams): QueryKeyResult => {
  return ['company-predefined-screener-list', limit, initPage, market];
};

const QUERY = gql(`
  query companyPredefinedScreeners(
    $limit: Int!
    $offset: Int!
    $additionalFilters: [AdditionalScreenerFilter!]
  ) {
    companyPredefinedScreeners(
      input: {
        limit: $limit
        offset: $offset
        additionalFilters: $additionalFilters
      }
    ) {
      id
      name
      description
      imageUrl
      slug
      type {
        id
        name
        description
        slug
      }
      resultPreview {
        totalHits
        newCompaniesTotalHits
        filterJson
        companies {
          id
          name
          tickerSymbol
          info {
            url
            hasLogo
          }
        }
        meta {
          searchRestrictions {
            isRestricted
            restrictionCode
            restrictionReason
            predefinedScreenerOwner
          }
          systemRestrictions {
            isRestricted
            restrictionCode
            restrictionReason
            maxResultCountForRecentCompanyFeature
          }
        }
      }
    }
  }
`);

export const queryFn = async ({
  queryKey: [_key, limit, initPage, market],
  pageParam = initPage,
}: QueryFunctionContext<QueryKeyResult, number>) => {
  const offset = pageParam * limit;
  const additionalFilters = getAdditionalFilters({
    market,
    industry: '',
  });
  const response = await gqlClient.request(QUERY, {
    limit,
    offset,
    additionalFilters,
  });

  return response.companyPredefinedScreeners;
};
